/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const adoAccountSummarySchema = z.object({
  accountId: z.string(),
  accountName: z.string(),
});
